// noinspection JSUnusedLocalSymbols

/**
 * Created by coolguy on 2017/4/15.
 */
import {
  Icon,
  Input,
  Radio,
  Button,
  Select,
  Slider,
  Switch,
  Checkbox,
  DatePicker,
  TimePicker,
  TreeSelect,
  InputNumber,
} from "antd";
import React from "react";
import * as R from "ramda";
import moment from "moment";

import Map from "../Select/Map";
import Editor from "../RichEditor";
import Price from "../Select/Price";
import DataTag from "../Select/DataTag";
import MoveTag from "../Select/MoveTag";
import Timeline from "../Select/Timeline";
import GuestList from "../Select/GuestList";
import MapDetail from "../Select/MapDetail";
import GuideTip from "../Common/GuideTip.js";
import Uploader from "../Common/Uploader.js";
import { expressList } from "@/defaultData.js";
import ColorPicker from "../Select/ColorPicker";
import UserCost from "../Select/UserCostSelect";
import ContactList from "../Select/ContactTable";
import ProductList from "../Select/ProductTable";
import UserSelect from "../Select/UserSelect.js";
import MultiUploader from "../Common/MultiUpload";
import BillInfoList from "../Select/BillInfoList";
import SearchSelect from "../Select/SearchSelect";
import SliderSelect from "../Select/SliderSelect.js";
import ActivitySelect from "../Select/ActivitySelect";
import ConsumerSelect from "../Select/ConsumerSelect";
import GallerySelect from "../Select/GallerySelect.js";
import ProductSelect from "../Select/ProductSelect.js";
import imageUtil, { getPhotoSrc } from "../../util/image";
import MultiVideoSelect from "../Select/MultiVideoSelect";
import MultiGallerySelect from "../Select/MultiGallerySelect";
import { SelectVideoSource } from "../Select/video-source-select";
import CheckboxPlus from "../Select/CheckboxPlus";

import "./Info.scss";

const { TextArea } = Input;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const { MonthPicker } = DatePicker;

export const processValue = (value) => {
  //  value instanceof moment === false && (value = moment((value||0)-0));
  const valueIsMomentType = value instanceof moment;
  if (value) {
    if (!valueIsMomentType) {
      const integerValue = parseInt(value || 0, 10);
      value = moment(integerValue);
    }
  } else {
    value = null;
  }
  return value;
};

export default class Info extends React.Component {
  static defaultProps = {
    useLabel: true,
  };

  changeValue = (e, whole) => {
    let value = e;
    let { type, pattern } = this.props;

    const directReturn = [
      "product-list",
      "treeselect",
      "contact",
      "multi-upload",
      "guest",
      "timeline",
      "search-select",
      "custom_tag",
      "multi-gallery-select",
      "multi-video-select",
      "video-source-select",
      "advisers",
    ];
    if (directReturn.indexOf(type) > -1 || this.props.directReturn === true) {
      this.props.onChange && this.props.onChange(value);
    } else {
      if (typeof e === "object") {
        if (e instanceof Array) {
          if (type === "slider") {
            value = e;
          } else if (type === "imagelist") {
            value = value.reduce((pre, current) => {
              if (current.key) {
                return pre.concat(current.key);
              } else {
                return pre.concat(current);
              }
            }, []);
          } else if (type === "usercost") {
            value = e;
          } else if (type === "gallery") {
            value = e;
          } else if (type === "custom") {
            value = e;
          } else {
            value = e.join(",");
          }
        } else if (type === "upload" || type === "file") {
          value = e.uploadParam.key;
        } else if (type === "tag" || type === "movetag") {
        } else if (type === "datetime") {
          value = e; //.format("YYYY-MM-DD HH:mm");
        } else if (type === "date") {
          console.log(e);
          value = e; //.format("YYYY-MM-DD");
        } else {
          //如果存在这个才赋值，否则直接用e本身
          if (e && e.target && e.target.value !== undefined) {
            value = e.target.value;
          }
        }
      }

      if (this.props.onChange) {
        if (pattern && pattern instanceof RegExp && typeof value == "string") {
          let result = value.match(pattern);
          value = result && result instanceof Array ? result.join(``) : "";
        }

        if (typeof whole != "undefined") {
          this.props.onChange(value, whole);
        } else {
          this.props.onChange(value);
        }
      }
    }
  };
  renderTreeSelect = (arr, value) => {
    return (
      <TreeSelect
        disabled={this.props.disabled}
        style={{ width: "100%" }}
        value={value}
        allowClear
        placeholder="请选择"
        treeData={arr}
        treeNodeLabelProp="name"
        treeDefaultExpandAll={true}
        onChange={this.changeValue}
      />
    );
  };
  renderSelect = (arr, value) => {
    // noinspection JSUnresolvedReference
    return (
      <Select
        placeholder="请选择"
        style={{ width: this.props.width || "auto" }}
        id={this.props.id}
        disabled={this.props.disabled}
        value={this.props.value}
        onChange={this.changeValue}
        dropdownRender={this.props.dropdownRender}
        {...(this.props.selectProps || {})}
        {...(this.props.selectOptions || [])}
        dropdownStyle={this.props.dropdownStyle}
        dropdownMenuStyle={this.props.dropdownMenuStyle}
        dropdownMatchSelectWidth={this.props.dropdownMatchSelectWidth}
      >
        {arr.map((v, i) => {
          return (
            <Option key={i} value={v.key} disabled={!!v.disabled}>
              {v.name}
            </Option>
          );
        })}
      </Select>
    );
  };
  renderExpress = (value) => {
    return (
      <Select
        placeholder="请选择快递公司"
        style={{ width: this.props.width || "auto" }}
        disabled={this.props.disabled}
        value={value}
        onChange={this.changeValue}
        mode="combobox"
        filterOptionProp={"children"}
      >
        {expressList.map((v, i) => {
          return (
            <Option key={i} value={v}>
              {v}
            </Option>
          );
        })}
      </Select>
    );
  };
  renderMulti = (arr, value) => {
    return (
      <Select
        optionFilterProp={"children"}
        mode="multiple"
        placeholder="请选择"
        style={{ width: this.props.width || "auto" }}
        id={this.props.id}
        disabled={this.props.disabled}
        value={this.props.value}
        onChange={this.changeValue}
      >
        {arr.map((v, i) => {
          return (
            <Option key={i} value={v.key}>
              {v.name}
            </Option>
          );
        })}
      </Select>
    );
  };
  renderMultiGallerySelect = (value) => {
    return (
      <MultiGallerySelect
        labelInValue={this.props.labelInValue}
        mode={this.props.mode}
        value={value}
        onChange={this.changeValue}
        width={this.props.width || "auto"}
        selectProps={this.props.selectProps}
        dropdownSearch={this.props.dropdownSearch}
        dropdownSearchPlaceholder={this.props.dropdownSearchPlaceholder}
        allowAllSelectAndDeselect={this.props.allowAllSelectAndDeselect}
      />
    );
  };
  renderMultiVideoSelect = (value) => {
    return (
      <MultiVideoSelect
        value={value}
        onChange={this.changeValue}
        width={this.props.width || "auto"}
        actionParams={this.props.actionParams}
        selectProps={this.props.selectProps}
      />
    );
  };

  renderVideoSourceSelect = (value) => {
    return (
      <SelectVideoSource
        value={value}
        onChange={this.changeValue}
        actionParams={this.props.actionParams}
      />
    );
  };

  renderRadio = (arr, value) => {
    return (
      <RadioGroup
        id={this.props.id}
        disabled={!!this.props.disabled}
        value={this.props.value}
        onChange={this.changeValue}
      >
        {arr.map((v, i) => {
          return (
            <Radio key={i} value={v.key} disabled={!!v.disabled}>
              {v.name}
            </Radio>
          );
        })}
      </RadioGroup>
    );
  };
  renderDateTime = () => {
    //console.log(this.props.value instanceof moment,"datetime");
    let { value } = this.props;
    value = processValue(value);
    return (
      <DatePicker
        id={this.props.id}
        showTime={Object.assign(
          { format: this.props.showSecond ? "HH:mm:ss" : "HH:mm" },
          this.props.showTime
        )}
        style={{ width: this.props.width * 1 || "100%" }}
        format={
          this.props.showSecond ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm"
        }
        placeholder={this.props.placeholder || "选择时间"}
        disabled={this.props.disabled}
        disabledDate={
          this.props.disabledDate
            ? function (val) {
              return (
                val &&
                (val < moment().startOf("day") || val > moment().endOf("day"))
              );
            }
            : null
        }
        value={value}
        disabledMinute={this.props.disabledMinute}
        onChange={this.changeValue}
      />
    );
  };
  renderTime = () => {
    let { format = "HH:mm:ss", value } = this.props;

    value = processValue(value);

    return (
      <TimePicker
        id={this.props.id}
        format={format}
        value={value}
        disabled={this.props.disabled}
        placeholder={this.props.placeholder}
        onChange={this.changeValue}
      />
    );
  };
  renderDate = () => {
    let { value } = this.props;
    value = processValue(value);
    return (
      <DatePicker
        style={{ width: "100%" }}
        id={this.props.id}
        disabled={this.props.disabled}
        format="YYYY-MM-DD"
        value={value}
        onChange={this.changeValue}
      />
    );
  };
  renderMonth = () => {
    let { value } = this.props;
    value = processValue(value);
    return (
      <MonthPicker
        style={{ width: this.props.width * 1 || "100%" }}
        format="YYYY-MM"
        value={value}
        onChange={this.changeValue}
      />
    );
  };
  renderInputNumber = (value) => {
    let { max, min, onChange, disabled, numberProps = {} } = this.props;
    // console.log(this.props);
    return (
      <InputNumber
        {...numberProps}
        addonAfter={this.props.addonAfter}
        disabled={disabled}
        defaultValue={value}
        max={max}
        min={min}
        step={this.props.step}
        onChange={onChange}
        formatter={this.props.formatter}
        parser={this.props.parser}
      />
    );
  };

  renderPrice = (value) => {
    return <Price value={value} {...this.props} />;
  };

  renderNumberSlider = (value) => {
    let { max, min, onChange, disabled, step } = this.props;
    return (
      <Slider
        max={max}
        min={min}
        onChange={onChange}
        disabled={disabled}
        value={value}
        step={step}
      />
    );
  };

  renderCheckbox = (value) => {
    return (
      <Checkbox
        checked={!!value}
        disabled={this.props.disabled}
        onChange={this.changeValue}
      ></Checkbox>
    );
  };

  renderInput = (id, value, type) => {
    const { textProps = {} } = this.props;
    return (
      <Input
        id={id}
        style={{ width: this.props.width || "100%", ...textProps.style }}
        type={type || "text"}
        defaultValue={value}
        maxLength={this.props.maxLength}
        prefix={this.props.prefix}
        suffix={this.props.suffix}
        disabled={this.props.disabled}
        readOnly={this.props.readOnly}
        placeholder={this.props.placeholder}
        addonBefore={this.props.addonBefore}
        addonAfter={this.props.addonAfter}
        value={this.props.value}
        max={this.props.max}
        min={this.props.min}
        onKeyDown={this.props.onKeyDown}
        onChange={this.changeValue}
      />
    );
  };

  renderProductSelect(value) {
    return (
      <ProductSelect
        value={value}
        onChange={this.changeValue}
        disabled={!!this.props.disabled}
        single={this.props.single}
      />
    );
  }
  renderUserSelect(value, filter) {
    return (
      <UserSelect
        value={value}
        onChange={this.changeValue}
        disabled={!!this.props.disabled}
        filter={filter}
        single={this.props.single}
      />
    );
  }
  renderConsumerSelect(value) {
    let { consumerObj } = this.props;
    //console.log(consumerObj,"Info")
    return (
      <ConsumerSelect
        showAdd={this.props.showAdd}
        consumerObj={consumerObj}
        value={value}
        disabled={!!this.props.disabled}
        onChange={this.changeValue}
        single={this.props.single}
        onSearch={this.props.onSearch}
      />
    );
  }
  renderSliderSelect(value) {
    return (
      <SliderSelect
        record={this.props.record}
        value={value}
        onChange={this.changeValue}
      />
    );
  }
  renderUpload(value) {
    const uploadStyle = this.props.uploadStyle || this.props.style;
    const actionMode = this.props.allowReplace || this.props.allowClear;
    const allowActions = !!value && (this.props.allowReplace || this.props.allowClear);

    if (actionMode && !value) {
      return (
        <div
          className="avatar-uploader-wrapper empty-actions"
          style={uploadStyle}
        >
          <Uploader
            wrapperStyle={{ width: "100%", marginBottom: 0 }}
            style={{ width: "100%", height: 120 }}
            className="upload-empty-trigger"
            uploadFinish={this.changeValue}
            accept={this.props.accept}
            directory={this.props.directory || "attachment"}
            limitSize={this.props.limitSize}
            showUploadList={false}
          >
            <Icon type="plus" className="avatar-uploader-trigger" />
          </Uploader>
          <div className="avatar-uploader-tip">{this.props.tip}</div>
        </div>
      );
    }

    if (allowActions) {
      return (
        <div
          className="avatar-uploader-wrapper has-actions"
          style={uploadStyle}
        >
          <div className="avatar-uploader-preview">
            <img
              src={getPhotoSrc({ photo: value })}
              alt="avatar"
              className="avatar"
            />
            <div className="avatar-uploader-actions">
              {this.props.allowReplace ? (
                <Uploader
                  wrapperStyle={{ width: "auto", marginBottom: 0 }}
                  style={{ display: "inline-block" }}
                  className="upload-replace-trigger"
                  uploadFinish={this.changeValue}
                  accept={this.props.accept}
                  directory={this.props.directory || "attachment"}
                  limitSize={this.props.limitSize}
                  showUploadList={false}
                >
                  <Button size="small">替换</Button>
                </Uploader>
              ) : null}
              {this.props.allowClear ? (
                <Button
                  size="small"
                  type="danger"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.props.onChange && this.props.onChange("");
                  }}
                >
                  删除
                </Button>
              ) : null}
            </div>
          </div>
          <div className="avatar-uploader-tip">{this.props.tip}</div>
        </div>
      );
    }

    return (
      <Uploader
        style={uploadStyle}
        className="dp-f a-c"
        uploadFinish={this.changeValue}
        accept={this.props.accept}
        directory={this.props.directory || "attachment"}
        tip={this.props.tip}
        limitSize={this.props.limitSize}
        showUploadList={false}
      >
        {value ? (
          <img
            src={getPhotoSrc({ photo: value })}
            alt="avatar"
            className="avatar"
          />
        ) : (
          <Icon type="plus" className="avatar-uploader-trigger" />
        )}
        <div className="avatar-uploader-tip">{this.props.tip}</div>
      </Uploader>
    );
  }
  renderUploadFile(value) {
    return (
      <Uploader
        style={this.props.style}
        className={"dp-f a-c uploadfile"}
        uploadFinish={this.changeValue}
        hideLoading={true}
        directory={this.props.directory || "attachment"}
        showUploadList={false}
        accept={this.props.accept}
        limitSize={this.props.limitSize}
      >
        <Button icon="upload">点击上传</Button>
        <div className="avatar-uploader-tip">{this.props.tip}</div>
      </Uploader>
    );
  }
  renderMultiUpload(valueArray) {
    if (typeof valueArray == "string") {
      valueArray = (valueArray.split(",") || [])
        .filter((it) => !!it)
        .map((it) => {
          return {
            url: imageUtil.getUrl(it),
            uid: it,
            status: "done",
            key: it,
            name: it,
          };
        });
    }
    valueArray = (valueArray || []).filter((it) => !!it);

    if (valueArray instanceof Array) {
      valueArray = valueArray.map((it) => {
        if (!it.uid) {
          return {
            uid: it,
            key: it,
            url: imageUtil.getUrl(it),
            status: "done",
            name: it,
          };
        }
        return it;
      });
    }

    return (
      <MultiUploader
        style={this.props.style}
        className="dp-f a-c"
        uploadFinish={this.changeValue}
        fileList={valueArray}
        tip={this.props.tip}
        listType={this.props.listType}
        disabled={this.props.disabled}
        uploadButton={this.props.uploadButton}
        maxCount={this.props.maxCount}
        limitSize={this.props.limitSize}
        multiple={this.props.multiple}
        directory={this.props.directory || "attachment"}
        showUploadList={this.props.showUploadList}
      ></MultiUploader>
    );
  }

  renderMoveTag(value) {
    return (
      <MoveTag
        value={value}
        staticTag={this.props.staticTag}
        onChange={this.changeValue}
        onRemove={this.props.onRemove}
      />
    );
  }

  renderDataTag(value) {
    return (
      <DataTag
        value={value}
        tagType={this.props.tagType}
        category={this.props.category}
        onChange={this.changeValue}
      />
    );
  }

  renderTag(data, value) {
    const props = {
      style: { width: "100%" },
      mode: "tags",
      searchPlaceholder: "请输入分类标签后回车确认",
      onChange: this.changeValue,
    };
    if (value instanceof Array) {
      value = value.filter((item) => {
        return !!item;
      });

      props.defaultValue = value;
    }
    return (
      <Select {...props}>
        {(data || []).map((item, index) => {
          return (
            <Select.Option key={index} value={item.key}>
              {item.value}
            </Select.Option>
          );
        })}
      </Select>
    );
  }

  renderCustomTag(value) {
    const props = {
      style: { width: "100%" },
      mode: "tags",
      searchPlaceholder: "逗号自动分词",
      onChange: this.changeValue,
      tokenSeparators: [","],
    };

    if (value instanceof Array) {
      value = value.filter((item) => {
        return !!item;
      });

      props.defaultValue = value;
    }

    return <Select {...props}></Select>;
  }

  renderColorPicker(value) {
    return (
      <ColorPicker
        onChange={this.changeValue}
        value={value}
        disabled={this.props.disabled}
      />
    );
  }

  renderSwitch(value) {
    return (
      <Switch
        checked={!!value}
        onChange={this.changeValue}
        disabled={this.props.disabled}
      />
    );
  }

  renderTextarea(value) {
    /**
     * 2025年03月18日 去掉了autoSize, 因为会导致屏幕闪烁
     * https://github.com/react-component/textarea/pull/23
     * @type {TextArea}
     */
    return (
      <TextArea
        style={{
          width: this.props.width || "auto",
          minHeight: this.props.minHeight || "auto",
          maxHeight: "100%",
        }}
        autoSize={
          typeof this.props.autoSize != "undefined"
            ? this.props.autoSize
            : { minRows: 2 }
        }
        onChange={this.changeValue}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        value={value}
      />
    );
  }
  renderCustom() {
    let { value, instance } = this.props;
    const Instance = instance;
    return <Instance onChange={this.changeValue} value={value} />;
  }
  renderProductList(data, value) {
    return (
      <ProductList
        selectedList={this.props.data}
        onChange={this.changeValue}
        ref="info"
        disabled={this.props.disabled}
        showPrice={this.props.showPrice}
      />
    );
  }
  renderContact(data, value) {
    return (
      <ContactList
        value={value}
        data={data}
        consumerid={this.props.consumerid}
        consumer={this.props.consumer}
        onChange={this.changeValue}
      />
    );
  }
  renderUserCost(value) {
    return (
      <UserCost
        name={this.props.name}
        value={value}
        onChange={this.changeValue}
        disabled={this.props.disabled}
        filter={this.props.filter}
      />
    );
  }
  renderGuest(value) {
    return (
      <GuestList
        value={value}
        onChange={this.changeValue}
        disabled={this.props.disabled}
      />
    );
  }
  renderMap(value) {
    return (
      <Map
        value={value}
        onChange={this.changeValue}
        disabled={this.props.disabled}
      />
    );
  }
  renderMapDetail(value) {
    return (
      <MapDetail
        value={value}
        onChange={this.changeValue}
        disabled={this.props.disabled}
      />
    );
  }
  renderTimeline(value) {
    return (
      <Timeline
        value={value}
        onChange={this.changeValue}
        disabled={this.props.disabled}
      />
    );
  }
  renderGallery(value) {
    return (
      <GallerySelect
        value={value}
        onChange={this.changeValue}
        parentGallery={this.props.parentGallery || "0"}
        disabled={this.props.disabled}
      />
    );
  }
  renderBillInfo(value) {
    let { consumerid } = this.props;
    return (
      <BillInfoList
        value={value}
        consumerid={consumerid}
        onChange={this.changeValue}
        disabled={this.props.disabled}
      />
    );
  }
  renderActivity(value) {
    return (
      <ActivitySelect
        value={value}
        onChange={this.changeValue}
        disableTreeNode={this.props.disableTreeNode}
        single={this.props.single}
      />
    );
  }
  renderSearchSelect(data) {
    return (
      <SearchSelect
        data={data}
        onChange={this.changeValue}
        onSearch={this.props.onSearch}
        onSelect={this.props.onSelect}
        selectStyle={this.props.selectStyle}
      />
    );
  }
  renderEditor(editorState) {
    return (
      <Editor
        value={editorState}
        editorState={editorState}
        onChange={this.props.onChange}
        showLength={this.props.showLength}
        maxLength={this.props.maxLength}
      />
    );
  }

  renderCheckboxGroup = (data, value) => {
    if (this.props.useAllCheck) {
      return <CheckboxPlus {...this.props} />;
    }
    return <Checkbox.Group value={value} options={data} onChange={this.props.onChange} />;
  };
  renderGalleryDownloadSelect = (gallery, value) => {
    const isCheckGallery = R.pathEq(1, ["check"], gallery);
    const onChange = R.pathOr(R.T, ["onChange"], this.props);
    if (isCheckGallery) {
      //  审核相册 通过{"check":"1"}, 不通过{"check":"2"}, 未审核{"check":"0"}
      return (
        <Select style={{ width: "100%" }} value={value} onChange={onChange}>
          <Option value="{}">全部</Option>
          <Option value='{"check":"1"}'>通过</Option>
          <Option value='{"check":"2"}'>不通过</Option>
          <Option value='{"check":"0"}'>未审核</Option>
        </Select>
      );
    } else {
      //  公开相册 公开{trash: '0'}, 隐藏 {"trash[!]":0}
      return (
        <Select style={{ width: "100%" }} value={value} onChange={onChange}>
          <Option value="{}">全部</Option>
          <Option value='{"trash":"0"}'>公开</Option>
          <Option value='{"trash[!]":"0"}'>隐藏</Option>
        </Select>
      );
    }
  };

  renderWhich = (data, value) => {
    let { type, id, filter } = this.props;
    switch (type) {
      case null:
        return null;
      case "select":
        return this.renderSelect(data, value);
      case "checkbox":
        return this.renderCheckbox(value);
      case "checkbox-group":
        return this.renderCheckboxGroup(data, value);
      case "radio":
        return this.renderRadio(data, value);
      case "datetime":
        return this.renderDateTime();
      case "month":
        return this.renderMonth();
      case "date":
        return this.renderDate();
      case "time":
        return this.renderTime();
      case "product":
        return this.renderProductSelect(value);
      case "user":
        return this.renderUserSelect(value, filter);
      case "consumer":
        return this.renderConsumerSelect(value);
      case "file":
        return this.renderUploadFile(value);
      case "upload":
        return this.renderUpload(value);
      case "multi-upload":
        return this.renderMultiUpload(value);
      case "imagelist":
        return this.renderMultiUpload(value);
      case "slider":
        return this.renderSliderSelect(value);
      case "tag":
        return this.renderTag(data, value);
      case "custom_tag":
        return this.renderCustomTag(value);
      case "datatag":
        return this.renderDataTag(value);
      case "switch":
        return this.renderSwitch(value);
      case "textarea":
        return this.renderTextarea(value);
      case "custom":
        return this.renderCustom();
      case "multi":
        return this.renderMulti(data, value);
      case "multi-gallery-select":
        return this.renderMultiGallerySelect(value);
      case "multi-video-select":
        return this.renderMultiVideoSelect(value);
      case "video-source-select":
        return this.renderVideoSourceSelect(value);
      case "contact":
        return this.renderContact(data, value);
      case "product-list":
        return this.renderProductList(data, value);
      case "treeselect":
        return this.renderTreeSelect(data, value);
      case "usercost":
        return this.renderUserCost(value);
      case "express":
        return this.renderExpress(value);
      case "guest":
        return this.renderGuest(value);
      case "map":
        return this.renderMap(value);
      case "mapdetail":
        return this.renderMapDetail(value);
      case "timeline":
        return this.renderTimeline(value);
      case "gallery":
        return this.renderGallery(value);
      case "number":
        return this.renderInputNumber(value);
      case "billinfo":
        return this.renderBillInfo(value);
      case "activity":
        return this.renderActivity(value);
      case "search-select":
        return this.renderSearchSelect(data, value);
      case "editor":
        return this.renderEditor(value);
      case "movetag":
        return this.renderMoveTag(value);
      case "numberslider":
        return this.renderNumberSlider(value);
      case "colorpicker":
        return this.renderColorPicker(value);
      case "price":
        return this.renderPrice(value);
      case "gallery-download-select":
        return this.renderGalleryDownloadSelect(data, value);
      //case "password":return this.renderInput(id,value,type);
      case "text":
        return this.renderInput(id, value, type);
      default:
        return this.renderInput(id, value, type);
    }
  };
  getValue = () => {
    // let {type,id} = this.props;
    // switch (type){
    //     case "select": return
    // }
  };
  render() {
    let {
      label,
      value,
      required,
      data,
      isText,
      className,
      useLabel,
      rightElement,
      tooltip,
      // 珊婷给的文案刚好折行了, 所以就搞一个 labelWidth 来控制 label 的宽度, 让它在一行显示
      labelWidth,
    } = this.props;
    return (
      <div
        className={className || "flex1 dp-f a-c form-info info-page-item"}
        style={Object.assign(
          { marginRight: 20, marginBottom: 10 },
          this.props.style
        )}
      >
        {useLabel ? (
          <div
            className="label"
            style={{
              width: labelWidth ? labelWidth : undefined,
            }}
          >
            {label}
            {required && <span className="required">*</span>}{" "}
            {tooltip ? <GuideTip tooltip={tooltip} /> : null}
          </div>
        ) : null}
        <div className="value flex1">
          {isText ? value : this.renderWhich(data, value)}
        </div>
        {rightElement ? rightElement : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Detail/Info.js